import { mapState, mapGetters } from 'vuex';
import { COIN_TYPE } from '@store/officialTopup/index';
export default {
  computed: {
    ...mapState({
      letter: state => state.letter,
      showCurrency: state => state.showCurrency,
      extraCoinType: state => state.extraCoinType,
      picList: state => state.page.picList,
      subCoinType: state => state.subCoinType
    }),
    ...mapGetters(['extraCoinName', 'subCoinNama']),
    configCoinIcon() {
      return this.picList?.coinIcon || '';
    },
    configVoucherCoinIcon() {
      return this.picList?.voucherCoinIcon || '';
    },
    configProductExtraCoinIcon() {
      return this.picList?.productExtraCoinIcon || '';
    },
    configCoinName() {
      return this.letter.v3ExtraCoinName || this.extraCoinName || '';
    },
    configVoucherCoinName() {
      return this.letter.v3ExtraVoucherName || this.extraCoinName || '';
    },
    configProductExtraCoinName() {
      return this.letter.v3ProductExtraCoinName || '';
    },
    showExtraIcon() {
      if (this.extraCoinType == COIN_TYPE) {
        return this.configCoinIcon;
      }
      return this.configVoucherCoinIcon;
    },
    showExtraName() {
      if (this.extraCoinType == COIN_TYPE) {
        return this.configCoinName;
      }
      return this.configVoucherCoinName;
    },
    showSubCoinIcon() {
      if (this.subCoinType == COIN_TYPE) {
        return this.configCoinIcon;
      }
      return this.configVoucherCoinIcon;
    },
    showSubCoinName() {
      if (this.subCoinType == COIN_TYPE) {
        return this.configCoinName;
      }
      return this.configVoucherCoinName;
    },
    showProductExtraCoinIcon() {
      return this.configProductExtraCoinIcon || this.showExtraIcon || '';
    },
    showProductExtraCoinName() {
      return this.configProductExtraCoinName || this.showExtraName || '';
    }
  }
};
